/* ===========================================================
   HESAP İŞLEM FİŞ HTML BUILDER
=========================================================== */

export const buildFisHTML = (
  fis,
  oncekiBakiye,
  sonBakiye,
  tarih,
  hesapAdi,
  firmaAdi,
  ziynetBakiyeler
) => {
  /* ===========================================================
     TR SAYI FORMAT

     15000     -> 15.000
     22000.05  -> 22.000,05
  =========================================================== */

  const fmtTR = (val, fractionDigits = null) => {
    if (
      val === null ||
      val === undefined ||
      val === ""
    ) {
      return "";
    }

    const num = Number(val);

    if (!Number.isFinite(num)) {
      return "";
    }

    const digits =
      fractionDigits === null
        ? Number.isInteger(num)
          ? 0
          : 2
        : fractionDigits;

    return num.toLocaleString("tr-TR", {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    });
  };

  /* ===========================================================
     FİŞ LİSTELERİ
  =========================================================== */

  const altinList =
    Array.isArray(fis?.altin)
      ? fis.altin
      : [];

  const ziynetList =
    Array.isArray(fis?.ziynet)
      ? fis.ziynet
      : [];

  const nakitList =
    Array.isArray(fis?.nakit)
      ? fis.nakit
      : [];

  const gramKarNakitList =
    Array.isArray(fis?.gramKarNakit)
      ? fis.gramKarNakit
      : [];

  const baglantiliList =
    Array.isArray(fis?.baglantili)
      ? fis.baglantili
      : [];

  const isNakitKarsiligiAltin =
    gramKarNakitList.length > 0;

  /* ===========================================================
     BAKİYELER
  =========================================================== */

  const onceki =
    oncekiBakiye || {
      gram: 0,
      tl: 0,
      usd: 0,
      eur: 0,
    };

  const son =
    sonBakiye || {
      gram: 0,
      tl: 0,
      usd: 0,
      eur: 0,
    };

  /* ===========================================================
     ZİYNET BAKİYELERİ
  =========================================================== */

  const zb =
    ziynetBakiyeler || {
      yeniAta: 0,
      yeniYarim: 0,
      yeniCeyrek: 0,
      eskiAta: 0,
      eskiYarim: 0,
      eskiCeyrek: 0,
    };

  /* ===========================================================
     FİŞ TOPLAMLARI

     Fiş Top. =
     Sonraki Bakiye - Önceki Bakiye
  =========================================================== */

  const islemToplam = {
    gram:
      (Number(son.gram) || 0) -
      (Number(onceki.gram) || 0),

    tl:
      (Number(son.tl) || 0) -
      (Number(onceki.tl) || 0),

    usd:
      (Number(son.usd) || 0) -
      (Number(onceki.usd) || 0),

    eur:
      (Number(son.eur) || 0) -
      (Number(onceki.eur) || 0),
  };

  /* ===========================================================
     SAFE DEĞERLER
  =========================================================== */

  const hesapAdiSafe =
    hesapAdi || "";

  const tarihSafe =
    tarih || "";

  const firmaAdiSafe =
    firmaAdi || "";

  /* ===========================================================
     HTML
  =========================================================== */

  return `
<!DOCTYPE html>

<html lang="tr">

<head>

  <meta charset="UTF-8" />

  <meta
    name="viewport"
    content="width=device-width, initial-scale=1.0"
  />

  <title>Fiş Önizleme</title>

  <style>

    /* ========================================================
       GENEL
    ======================================================== */

    * {
      box-sizing: border-box;
    }

    html,
    body {
      margin: 0;
      padding: 0;
    }

    @page {
      size: 75mm auto !important;
      margin: 0 !important;
    }

    body {
      display: flex;
      justify-content: center;
      align-items: flex-start;

      width: 100%;

      margin: 0;
      padding: 0;

      background: #f3f3f3;

      color: #000;

      font-family:
        Arial,
        Helvetica,
        sans-serif;

      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    /* ========================================================
       FİŞ ANA ALANI
    ======================================================== */

    .preview-wrapper {
      width: 75mm;
      min-width: 75mm;
      max-width: 75mm;

      margin-top: 10px;
      padding: 8px;

      background: #ffffff;

      color: #000000;

      border-radius: 6px;

      box-shadow:
        0 0 8px
        rgba(0, 0, 0, 0.15);

      overflow: hidden;
    }

    /* ========================================================
       BAŞLIK
    ======================================================== */

    .header-title {
      width: 100%;

      text-align: center;

      font-size: 13px;
      font-weight: bold;

      line-height: 1.2;

      margin-bottom: 4px;
    }

    .header-date {
      width: 100%;

      text-align: center;

      font-size: 11px;

      line-height: 1.25;
    }

    .header-account {
      width: 100%;

      text-align: left;

      font-size: 11px;

      line-height: 1.25;

      margin-top: 5px;
    }

    /* ========================================================
       BÖLÜM BAŞLIKLARI
    ======================================================== */

    .section-title {
      width: 100%;

      text-align: center;

      font-size: 10px;
      font-weight: bold;

      line-height: 1.2;

      margin-top: 8px;
      margin-bottom: 2px;

      padding-bottom: 1px;

      border-bottom:
        1px solid #999;
    }

    /* ========================================================
       GENEL TABLO
    ======================================================== */

    table {
      width: 100%;

      border-collapse: collapse;
      border-spacing: 0;

      margin-top: 6px;
    }

    th {
      border-bottom:
        1px solid #444;

      font-size: 10px;
      font-weight: bold;

      line-height: 1.15;

      padding: 0 0 3px 0;

      vertical-align: bottom;
    }

    td {
      font-size: 10px;

      line-height: 1.15;

      padding: 2px 0;

      vertical-align: top;
    }

    /* ========================================================
       ALTIN TABLOSU

       1 = A/V
       2 = Cinsi
       3 = Miktar
       4 = mm
       5 = Has
       6 = Adet
       7 = İşç.
       8 = Top.
    ======================================================== */

    table.altin-table {
      width: 100%;
    }

    table.altin-table th:nth-child(1),
    table.altin-table td:nth-child(1) {
      width: 30px !important;
      max-width: 30px !important;

      text-align: left !important;

      white-space: nowrap;
    }

    table.altin-table th:nth-child(2),
    table.altin-table td:nth-child(2) {
      width: 15%;

      text-align: right;
    }

    table.altin-table th:nth-child(3),
    table.altin-table td:nth-child(3) {
      width: 18%;

      text-align: right;

      white-space: nowrap;
    }

    table.altin-table th:nth-child(4),
    table.altin-table td:nth-child(4) {
      width: 10%;

      text-align: right;

      white-space: nowrap;
    }

    table.altin-table th:nth-child(5),
    table.altin-table td:nth-child(5) {
      width: 20%;

      text-align: right;

      white-space: nowrap;
    }

    table.altin-table th:nth-child(6),
    table.altin-table td:nth-child(6) {
      width: 10%;

      text-align: right;

      white-space: nowrap;
    }

    table.altin-table th:nth-child(7),
    table.altin-table td:nth-child(7) {
      width: 10%;

      text-align: right;

      white-space: nowrap;
    }

    table.altin-table th:nth-child(8),
    table.altin-table td:nth-child(8) {
      width: 22%;

      text-align: right;

      white-space: nowrap;
    }

    /* ========================================================
       ZİYNET TABLOSU

       1 = Miktar
       2 = Cinsi
       3 = A/V
    ======================================================== */

    table.ziynet-table {
      width: 100%;

      table-layout: fixed;
    }

    table.ziynet-table th:nth-child(1),
    table.ziynet-table td:nth-child(1) {
      width: 25% !important;

      text-align: right !important;

      white-space: nowrap;
    }

    table.ziynet-table th:nth-child(2),
    table.ziynet-table td:nth-child(2) {
      width: 45% !important;

      text-align: right !important;
    }

    table.ziynet-table th:nth-child(3),
    table.ziynet-table td:nth-child(3) {
      width: 30% !important;

      text-align: right !important;

      white-space: nowrap;
    }

    /* ========================================================
       NAKİT TABLOSU

       1 = Miktar
       2 = Birim
       3 = A/V
    ======================================================== */

    table.nakit-table {
      width: 100%;

      table-layout: fixed;
    }

    table.nakit-table th:nth-child(1),
    table.nakit-table td:nth-child(1) {
      width: 40% !important;

      text-align: right !important;

      white-space: nowrap;
    }

    table.nakit-table th:nth-child(2),
    table.nakit-table td:nth-child(2) {
      width: 30% !important;

      text-align: right !important;

      white-space: nowrap;
    }

    table.nakit-table th:nth-child(3),
    table.nakit-table td:nth-child(3) {
      width: 30% !important;

      text-align: right !important;

      white-space: nowrap;
    }

    /* ========================================================
       ALTIN KARŞILIĞI NAKİT

       1 = A/V
       2 = Miktar
       3 = Birim
       4 = Br. Kur
       5 = Has Fiy.
       6 = Has Gr.
    ======================================================== */

    table.gramkarnakit-table {
      width: 100%;

      table-layout: fixed;
    }

    table.gramkarnakit-table th,
    table.gramkarnakit-table td {
      font-size: 9px;

      white-space: nowrap;
    }

    table.gramkarnakit-table th:nth-child(1),
    table.gramkarnakit-table td:nth-child(1) {
      width: 8% !important;

      text-align: left !important;
    }

    table.gramkarnakit-table th:nth-child(2),
    table.gramkarnakit-table td:nth-child(2) {
      width: 20% !important;

      text-align: left !important;
    }

    table.gramkarnakit-table th:nth-child(3),
    table.gramkarnakit-table td:nth-child(3) {
      width: 15% !important;

      text-align: left !important;
    }

    table.gramkarnakit-table th:nth-child(4),
    table.gramkarnakit-table td:nth-child(4) {
      width: 22% !important;

      text-align: left !important;

      white-space: nowrap;
    }

    table.gramkarnakit-table th:nth-child(5),
    table.gramkarnakit-table td:nth-child(5) {
      width: 22% !important;

      text-align: left !important;

      white-space: nowrap;
    }

    table.gramkarnakit-table th:nth-child(6),
    table.gramkarnakit-table td:nth-child(6) {
      width: 18% !important;

      text-align: left !important;
    }

    /* ========================================================
       BAĞLANTILI İŞLEMLER

       1 = İlk Miktar
       2 = İlk Birim
       3 = Son Miktar
       4 = Son Birim
    ======================================================== */

    table.baglantili-table {
      width: 100%;

      table-layout: fixed;
    }

    table.baglantili-table th,
    table.baglantili-table td {
      white-space: nowrap;

      font-size: 9px;
    }

    table.baglantili-table th:nth-child(1),
    table.baglantili-table td:nth-child(1) {
      width: 30% !important;

      text-align: right !important;
    }

    table.baglantili-table th:nth-child(2),
    table.baglantili-table td:nth-child(2) {
      width: 20% !important;

      text-align: center !important;
    }

    table.baglantili-table th:nth-child(3),
    table.baglantili-table td:nth-child(3) {
      width: 30% !important;

      text-align: right !important;
    }

    table.baglantili-table th:nth-child(4),
    table.baglantili-table td:nth-child(4) {
      width: 20% !important;

      text-align: center !important;
    }

    /* ========================================================
       BAKİYE TABLOSU

       DOĞRU SIRA:

       1 = Önceki
       2 = Sonraki
       3 = Fiş Top.
       4 = Birim
    ======================================================== */

    table.bakiye-table {
      width: 100%;

      table-layout: fixed;
    }

    table.bakiye-table th,
    table.bakiye-table td {
      white-space: nowrap;
    }

    table.bakiye-table th:nth-child(1),
    table.bakiye-table td:nth-child(1) {
      width: 28% !important;

      text-align: right !important;
    }

    table.bakiye-table th:nth-child(2),
    table.bakiye-table td:nth-child(2) {
      width: 28% !important;

      text-align: right !important;
    }

    table.bakiye-table th:nth-child(3),
    table.bakiye-table td:nth-child(3) {
      width: 28% !important;

      text-align: right !important;
    }

    table.bakiye-table th:nth-child(4),
    table.bakiye-table td:nth-child(4) {
      width: 16% !important;

      text-align: right !important;

      font-weight: bold;
    }

    /* ========================================================
       ZİYNET BAKİYELERİ
    ======================================================== */

    table.ziynet-bakiye-table {
      width: 100%;

      table-layout: fixed;
    }

    table.ziynet-bakiye-table th,
    table.ziynet-bakiye-table td {
      width: 16.6666%;

      font-size: 9px;

      padding: 2px 0;

      white-space: nowrap;

      text-align: right !important;
    }

    table.ziynet-bakiye-table th {
      border-bottom:
        1px solid #444;
    }

    /* ========================================================
       FOOTER
    ======================================================== */

    .footer {
      width: fit-content;

      margin:
        8px auto 0 auto;

      padding-top: 4px;

      text-align: center;

      font-size: 10px;

      white-space: nowrap;

      border-top:
        1px dashed #000;

      background:
        #fff !important;
    }

    /* ========================================================
       MASAÜSTÜ PRINT
    ======================================================== */

    @media print {

      html,
      body {
        width: 75mm !important;

        margin: 0 !important;
        padding: 0 !important;

        background:
          #ffffff !important;
      }

      body {
        display: block !important;
      }

      .preview-wrapper {
        width: 75mm !important;

        min-width: 75mm !important;
        max-width: 75mm !important;

        margin: 0 !important;

        padding: 8px !important;

        border-radius: 0 !important;

        box-shadow:
          none !important;
      }

    }

    /* ========================================================
       MOBİL

       Mobil Bluetooth baskıda bu HTML aynı şekilde raster
       görüntüye dönüştürüleceği için fiş genişliği kesinlikle
       responsive şekilde küçültülmez.

       PC ile mobil aynı 75mm tasarımı kullanır.
    ======================================================== */

    @media screen and (max-width: 768px) {

      html,
      body {
        margin: 0;
        padding: 0;
      }

      body {
        justify-content: center;
      }

      .preview-wrapper {
        width: 75mm !important;

        min-width: 75mm !important;
        max-width: 75mm !important;

        margin-top: 0;
      }

    }

  </style>

</head>

<body>

  <!-- =========================================================
       fis-root

       Mobil Bluetooth raster baskıda
       HtmlToEscPosRaster.js bu alanı görüntüye dönüştürür.
  ========================================================== -->

  <div
    id="fis-root"
    class="preview-wrapper"
  >

    <!-- =====================================================
         BAŞLIK
    ====================================================== -->

    <div class="header-title">
      ${firmaAdiSafe}
    </div>

    <div class="header-date">
      Tarih: ${tarihSafe}
    </div>

    <div class="header-account">
      Hesap: ${hesapAdiSafe}
    </div>

    <!-- =====================================================
         ALTIN İŞLEMLERİ
    ====================================================== -->

    ${
      altinList.length > 0
        ? `

      <div class="section-title">
        ALTIN İŞLEMLERİ
      </div>

      <table class="altin-table">

        <thead>

          <tr>

            <th>
              A/V
            </th>

            <th>
              Cinsi
            </th>

            <th>
              Miktar
            </th>

            <th>
              mm
            </th>

            <th>
              Has
            </th>

            <th>
              Adet
            </th>

            <th>
              İşç.
            </th>

            <th>
              Top.
            </th>

          </tr>

        </thead>

        <tbody>

          ${altinList
            .map(
              (r) => `

            <tr>

              <td>
                ${
                  r?.islemTur?.endsWith(
                    "ALINDI"
                  )
                    ? "A"
                    : "V"
                }
              </td>

              <td>
                ${
                  r?.stokAdi ||
                  ""
                }
              </td>

              <td>
                ${fmtTR(
                  r?.miktar,
                  2
                )}
              </td>

              <td>
                ${fmtTR(
                  r?.milyem,
                  0
                )}
              </td>

              <td>
                ${fmtTR(
                  r?.hasGram,
                  2
                )}
              </td>

              <td>
                ${fmtTR(
                  r?.adet,
                  0
                )}
              </td>

              <td>
                ${fmtTR(
                  r?.iscilik,
                  0
                )}
              </td>

              <td>
                ${fmtTR(
                  (
                    Number(
                      r?.hasGram
                    ) || 0
                  ) +
                  (
                    Number(
                      r?.iscilikGram
                    ) || 0
                  ),
                  2
                )}
              </td>

            </tr>

          `
            )
            .join("")}

        </tbody>

      </table>

    `
        : ""
    }

    <!-- =====================================================
         ZİYNET İŞLEMLERİ
    ====================================================== -->

    ${
      ziynetList.length > 0
        ? `

      <div class="section-title">
        ZİYNET İŞLEMLERİ
      </div>

      <table class="ziynet-table">

        <thead>

          <tr>

            <th>
              Miktar
            </th>

            <th>
              Cinsi
            </th>

            <th>
              A/V
            </th>

          </tr>

        </thead>

        <tbody>

          ${ziynetList
            .map(
              (r) => `

            <tr>

              <td>
                ${fmtTR(
                  r?.miktar,
                  0
                )}
              </td>

              <td>
                ${
                  r?.stokAdi ||
                  ""
                }
              </td>

              <td>
                ${
                  r?.islemTur?.endsWith(
                    "ALINDI"
                  )
                    ? "Alındı"
                    : "Verildi"
                }
              </td>

            </tr>

          `
            )
            .join("")}

        </tbody>

      </table>

    `
        : ""
    }

    <!-- =====================================================
         NAKİT İŞLEMLERİ
    ====================================================== -->

    ${
      nakitList.length > 0
        ? `

      <div class="section-title">
        NAKİT İŞLEMLERİ
      </div>

      <table class="nakit-table">

        <thead>

          <tr>

            <th>
              Miktar
            </th>

            <th>
              Birim
            </th>

            <th>
              A/V
            </th>

          </tr>

        </thead>

        <tbody>

          ${nakitList
            .map(
              (r) => `

            <tr>

              <td>
                ${fmtTR(
                  r?.miktar,
                  2
                )}
              </td>

              <td>
                ${
                  r?.birim ||
                  ""
                }
              </td>

              <td>
                ${
                  r?.islemTur?.endsWith(
                    "ALINDI"
                  )
                    ? "Alındı"
                    : "Verildi"
                }
              </td>

            </tr>

          `
            )
            .join("")}

        </tbody>

      </table>

    `
        : ""
    }

    <!-- =====================================================
         ALTIN KARŞILIĞI NAKİT
    ====================================================== -->

    ${
      isNakitKarsiligiAltin
        ? `

      <div class="section-title">
        ALTIN KARŞILIĞI NAKİT
      </div>

      <table class="gramkarnakit-table">

        <thead>

          <tr>

            <th>
              A/V
            </th>

            <th>
              Miktar
            </th>

            <th>
              Birim
            </th>

            <th>
              Br. Kur
            </th>

            <th>
              Has Fiy.
            </th>

            <th>
              Has Gr.
            </th>

          </tr>

        </thead>

        <tbody>

          ${gramKarNakitList
            .map(
              (r) => `

            <tr>

              <td>
                ${
                  r?.islemTur?.endsWith(
                    "ALINDI"
                  )
                    ? "A"
                    : "V"
                }
              </td>

              <td>
                ${fmtTR(
                  r?.miktar,
                  2
                )}
              </td>

              <td>
                ${
                  r?.birim ||
                  ""
                }
              </td>

              <td>
                ${fmtTR(
                  r?.birimKur,
                  2
                )}
              </td>

              <td>
                ${fmtTR(
                  r?.guncelKur,
                  2
                )}
              </td>

              <td>
                ${fmtTR(
                  r?.gram ?? r?.toplam,
                  2
                )}
              </td>

            </tr>

          `
            )
            .join("")}

        </tbody>

      </table>

    `
        : ""
    }

    <!-- =====================================================
         BAĞLANTILI İŞLEMLER
    ====================================================== -->

    ${
      baglantiliList.length > 0
        ? `

      <div class="section-title">
        BAĞLANTILI İŞLEMLER
      </div>

      <table class="baglantili-table">

        <thead>

          <tr>

            <th>
              İlk Miktar
            </th>

            <th>
              İlk Birim
            </th>

            <th>
              Son Miktar
            </th>

            <th>
              Son Birim
            </th>

          </tr>

        </thead>

        <tbody>

          ${baglantiliList
            .map(
              (r) => `

            <tr>

              <td>
                ${fmtTR(
                  r?.ilkMiktar,
                  2
                )}
              </td>

              <td>
                ${
                  r?.ilkBirim ||
                  ""
                }
              </td>

              <td>
                ${fmtTR(
                  r?.sonMiktar,
                  2
                )}
              </td>

              <td>
                ${
                  r?.sonBirim ||
                  ""
                }
              </td>

            </tr>

          `
            )
            .join("")}

        </tbody>

      </table>

    `
        : ""
    }

    <!-- =====================================================
         BAKİYE

         DOĞRU KOLON SIRASI:

         Önceki
         Sonraki
         Fiş Top.
         Birim
    ====================================================== -->

    <div class="section-title">
      BAKİYE
    </div>

    <table class="bakiye-table">

      <thead>

        <tr>

          <th>
            Önceki
          </th>

          <th>
            Sonraki
          </th>

          <th>
            Fiş Top.
          </th>

          <th>
            Birim
          </th>

        </tr>

      </thead>

      <tbody>

        <!-- =========================
             GRAM
        ========================== -->

        <tr>

          <td>
            ${fmtTR(
              onceki.gram,
              2
            )}
          </td>

          <td>
            ${fmtTR(
              son.gram,
              2
            )}
          </td>

          <td>
            ${fmtTR(
              islemToplam.gram,
              2
            )}
          </td>

          <td>
            Gram
          </td>

        </tr>

        <!-- =========================
             TL
        ========================== -->

        <tr>

          <td>
            ${fmtTR(
              onceki.tl,
              2
            )}
          </td>

          <td>
            ${fmtTR(
              son.tl,
              2
            )}
          </td>

          <td>
            ${fmtTR(
              islemToplam.tl,
              2
            )}
          </td>

          <td>
            TL
          </td>

        </tr>

        <!-- =========================
             USD
        ========================== -->

        <tr>

          <td>
            ${fmtTR(
              onceki.usd,
              2
            )}
          </td>

          <td>
            ${fmtTR(
              son.usd,
              2
            )}
          </td>

          <td>
            ${fmtTR(
              islemToplam.usd,
              2
            )}
          </td>

          <td>
            USD
          </td>

        </tr>

        <!-- =========================
             EUR
        ========================== -->

        <tr>

          <td>
            ${fmtTR(
              onceki.eur,
              2
            )}
          </td>

          <td>
            ${fmtTR(
              son.eur,
              2
            )}
          </td>

          <td>
            ${fmtTR(
              islemToplam.eur,
              2
            )}
          </td>

          <td>
            EUR
          </td>

        </tr>

      </tbody>

    </table>

    <!-- =====================================================
         ZİYNET BAKİYELERİ
    ====================================================== -->

    ${
      ziynetList.length > 0
        ? `

      <div class="section-title">
        ZİYNET BAKİYELERİ
      </div>

      <table class="ziynet-bakiye-table">

        <thead>

          <tr>

            <th>
              Y. Ata
            </th>

            <th>
              Y. Yrm
            </th>

            <th>
              Y. Çyr
            </th>

            <th>
              E. Ata
            </th>

            <th>
              E. Yrm
            </th>

            <th>
              E. Çyr
            </th>

          </tr>

        </thead>

        <tbody>

          <tr>

            <td>
              ${fmtTR(
                zb.yeniAta,
                0
              )}
            </td>

            <td>
              ${fmtTR(
                zb.yeniYarim,
                0
              )}
            </td>

            <td>
              ${fmtTR(
                zb.yeniCeyrek,
                0
              )}
            </td>

            <td>
              ${fmtTR(
                zb.eskiAta,
                0
              )}
            </td>

            <td>
              ${fmtTR(
                zb.eskiYarim,
                0
              )}
            </td>

            <td>
              ${fmtTR(
                zb.eskiCeyrek,
                0
              )}
            </td>

          </tr>

        </tbody>

      </table>

    `
        : ""
    }

    <!-- =====================================================
         FOOTER
    ====================================================== -->

    <div class="footer">
      MALİ DEĞERİ YOKTUR
    </div>

  </div>

</body>

</html>
  `;
};